import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseCircleEmpty = ({ className }: IProps) => (
    <svg
        className={className}
        version="1.1"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z" />
    </svg>
);

export const CircleEmpty = styled(BaseCircleEmpty)``;
